import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OTPChannels } from 'src/app/interfaces';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.css']
})
export class OtpInputComponent implements OnInit {
  otpChannels = OTPChannels
  resendDisabled: boolean;
  resendTimer: number;
  validOTP: boolean = false;
  submitting: boolean = false;
  verificationCode: string = "";
  isEmailContact: boolean = false;
  OTPConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
  }
  private _userContact: string = "";

  @Input()
  set userContact(value: string) {
    this._userContact = value ?? "";
    this.isEmailContact = this._userContact.includes('@');
  }

  get userContact(): string {
    return this._userContact;
  }

  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @Output() onGoBack: EventEmitter<any> = new EventEmitter(); // TODO: Remove
  @Output() onResendCode: EventEmitter<OTPChannels> = new EventEmitter<OTPChannels>();

  ngOnInit(): void {
    this.resetDisabledTimer();
  }

  resetDisabledTimer() {
    this.resendDisabled = true;
    this.resendTimer = 30;
    let timer = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer == 0) {
        this.resendDisabled = false;
        clearInterval(timer);
      }
    }, 1000);
  }

  onOTPChange(otpCode: string) {
    this.verificationCode = otpCode;
    if (otpCode.length == 6) {
      this.validOTP = true;
    }
    else {
      this.validOTP = false;
    }
    // The user edited the code so allow submitting again.
    this.submitting = false;
  }

  submit() {
    // Guard against double-submit.
    if (!this.validOTP || this.submitting) {
      return;
    }
    this.submitting = true;
    this.onSubmit.emit(this.verificationCode);
  }

  resendCode(channel: OTPChannels) {
    this.submitting = false;
    this.resetDisabledTimer();
    this.onResendCode.emit(channel);
  }

}
